import script from "./CalendarioAcreditacionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalendarioAcreditacionView.vue?vue&type=script&lang=ts&setup=true"

import "./CalendarioAcreditacionView.vue?vue&type=style&index=0&id=62919a95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62919a95"]])

export default __exports__